import styled from "styled-components";

import { ERROR_PRIMARY, WHITE } from "@/constants/colors";
import { BODY, REGULAR } from "@/constants/fonts";
import { constants } from "@thecb/components";

export const PillContainer = styled.div`
  height: 26px;
  color: ${WHITE};
  background-color: ${({ isError }) =>
    isError ? ERROR_PRIMARY : constants.colors.LUCKY_POINT};
  border-radius: 2px;
  font-size: 14px;
  font-family: ${BODY};
  font-weight: ${REGULAR};
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 600px;
  width: fit-content;
  white-space: nowrap;
`;

export const PillCloseIconWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const PillValueStatic = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PillValueInput = styled.input`
  border: transparent;
  background: transparent;
  color: ${WHITE};
  font-size: 14px;
  font-family: ${BODY};
  font-weight: ${REGULAR};
  &:focus {
    outline: none;
  }
  flex-grow: 1;
  width: 0;
`;

export const PillValueContainer = styled.div`
  display: inline-block;
  max-width: 400px;
  padding-left: 8px;
`;

export const PillValueInputWrapper = styled.div`
  display: flex;
`;

export const PillValueDummyText = styled.div`
  font-size: 14px;
  height: 0;
  font-family: ${BODY};
  font-weight: ${REGULAR};
  padding-right: 12px;
  color: rgba(0, 0, 0, 0);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
`;
